import {
  EInvoiceAddressSchemeType,
  EInvoiceScheme,
  EntityType,
  getDefaultAddressSchemeTypeByCountry,
  getEInvoiceCountryConfig,
} from '@components'

interface ResolveEInvoiceConfigOptions {
  countryId?: string
  ean?: string
  eInvoiceScheme?: EInvoiceScheme
  publicEntityRoutingEnabled?: boolean
}
interface EInvoiceConfig {
  eInvoiceAddress?: string
  entityType: EntityType
  scheme?: EInvoiceAddressSchemeType
}

export const resolveEInvoiceConfig = ({
  countryId,
  ean,
  eInvoiceScheme,
  publicEntityRoutingEnabled,
}: ResolveEInvoiceConfigOptions): EInvoiceConfig => {
  const eInvoiceConfig = getEInvoiceCountryConfig(countryId)
  const { defaultPrivateScheme, isFixedScheme = false, isPublicEntitySupported = true } = eInvoiceConfig || {}

  const isPublicEntityEnabled = !!publicEntityRoutingEnabled
  const entityType = isPublicEntitySupported && isPublicEntityEnabled ? EntityType.Public : EntityType.Private
  const isPublicEntitySelected = entityType === EntityType.Public
  const defaultScheme = getDefaultAddressSchemeTypeByCountry(isPublicEntitySelected, countryId)

  return {
    eInvoiceAddress: isPublicEntityEnabled && !isPublicEntitySupported ? '' : ean,
    entityType,
    scheme: isFixedScheme ? defaultPrivateScheme : eInvoiceScheme || defaultScheme,
  }
}
